<style lang="scss">
.Location {
    width: 90%;
    margin: 0 auto;

       .table {
        width: 100%;

        .sorting {
            background-image: url('/images/sort_both.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
        .sorting_asc {
            background-image: url('/images/sort_asc.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
        .sorting_desc {
            background-image: url('/images/sort_desc.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
    }

}


h1 {
    text-align: center;
    font-size: 30px;
}
</style>

<template>
<div>
    <div class="Location" v-if="$gate.isAdmin() || $gate.isReception() || $gate.isManager() || $gate.isSupervisor()">

            <div class="row">
                <div class="col-sm-11">
                    <input type="text" class="form-control" v-model="tableData.search" placeholder="Search" @input="getLocations()">
                </div>
                <div class="col-sm-1">
                    <select class="form-control" v-model="tableData.length" @change="getLocations()">
                        <option v-for="(records, index) in perPage"
                        :key="index"
                        :value="records">{{records}}</option>
                    </select>
                </div>

                <div class="col-sm-12 mt-2">
                    <datatable :columns="columns"
                        :sortKey="sortKey"
                        :sortOrders="sortOrders"
                        @sort="sortBy">

                        <tbody>
                            <tr v-for="location in locations" :key="location.id">
                                <td>{{location.name}}</td>
                                <td>{{location.xero}}</td>
                                <td>
                                    <button type="button" class="btn btn-info btn-lg" data-toggle="modal" :data-target="'#vmbc'+ location.id"><i class="fa fa-edit blue"></i></button>

                                        <!-- Modal -->
                                        <div class="modal fade" :id="'vmbc'+ location.id" role="dialog">
                                            <div class="modal-dialog">

                                            <!-- Modal content-->
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h4 class="modal-title">{{location.name}}</h4>
                                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                                </div>

                                                <div class="modal-body">
                                                    <input type="text" class="form-control mt-1" v-model="location.xero" placeholder="xero">
                                                </div>

                                                <div class="modal-footer">
                                                    <button type="button" class="btn btn-success" @click="updateLocation(location)"><i class="fa fa-save"></i></button>
                                                    <button type="button" class="btn btn-default" data-dismiss="modal"><i class="fa fa-times"></i></button>
                                                </div>
                                            </div>

                                            </div>
                                        </div>

                                </td>
                            </tr>
                        </tbody>
                    </datatable>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-4">
                    <excel
                        class = "btn btn-info"
                        :fetch   = "fetchExport"
                        :fields = "exportFields"
                        type    = "csv"
                        name = "Location.xls">
                        Download Excel
                    </excel>
                </div>
                <div class="col-sm-5">

                </div>
                <div class="col-sm-3">
                    <pagination :pagination="pagination"
                        @prev="getLocations(pagination.prevPageUrl)"
                        @next="getLocations(pagination.nextPageUrl)">
                </pagination>
                </div>
            </div>

    </div>
    <div class="row" v-else>
            <notfound></notfound>
    </div>
</div>
</template>


<script>
import Datatable from './../datatable/Datatable.vue';
import Pagination from './../datatable/Pagination.vue';

import JsonExcel from 'vue-json-excel'

export default {
    components: {datatable: Datatable, pagination: Pagination, excel: JsonExcel},
    data() {
        let sortOrders = {};
        let columns = [
            {width: '70%', label: 'Location', name: 'name'},
            {width: '10%', label: 'Xero', name: 'xero'},
            {width: '20%', label: 'Action', name: 'action'},
        ];

        columns.forEach((column) => {
            sortOrders[column.name] = -1;
        });

        return {
            locations: [],
            columns: columns,
            sortKey: 'deadline',
            sortOrders: sortOrders,
            perPage: ['5', '10', '20', '30'],
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
                user_id: this.$root.id,
                name: this.$root.staffname,
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
            },
            exportFields: {
                'Location Name': 'venuename',
                'Xero': 'xero',
            },
        }
    },
    created(){
        this.getLocations();
    },
    methods: {
        getLocations(url = '/api/locations'){
            this.tableData.draw++;
            axios
            .get(url, {params: this.tableData})
            .then(response => {
                let data = response.data;
                if(this.tableData.draw = data.draw) {
                    this.locations = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        configPagination(data) {
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = this.sortOrders[key] === 1? 'asc' : 'desc';
            this.getLocations();
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

        async fetchExport () {
            const response = await axios.get('/api/exportlocation');
            console.log(response);
            return response.data;
        },

        updateLocation(location){
            axios.post('./api/Location/Update', {
                    id: location.id,
                    name: location.name,
                    xero: location.xero,
                    price: location.price,
                    notes: location.notes
                })
                .then(function (response) {
                    console.log(response);
                    $('.modal').modal('hide');
                })
                .catch(function (error) {
                    console.log(error);
                });

        }
     }
}
</script>




// WEBPACK FOOTER //
// resources/js/Item/Location.vue